import ContainerizedImage from "../../../../src/components/ContainerizedImage";
import linearGraph from "../../../../src/images/blog/linear-knowledge-time.png";
import exponentialGraph from "../../../../src/images/blog/exponential-knowledge-time.png";
import * as React from 'react';
export default {
  ContainerizedImage,
  linearGraph,
  exponentialGraph,
  React
};